export const link = {
  github: "https://github.com/Moomi98",
  blog: "https://velog.io/@kymkjh2002",
};
